import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TableContainer,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import { VisitorStickerPrint } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {},
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  },
  nodata: {
    padding: theme.spacing(2)
  }
}));

const Results = props => {
  const {
    className,
    onPageChange,
    onPageLimit,
    orders,
    totalcount,
    page,
    rowsPerPage,
    ...rest
  } = props;

  const classes = useStyles();
  const [printVisitor, setPrintVisitor] = useState(null);

  const handleChangePage = (event, newPage) => {
    onPageChange(event, newPage);
  };

  const handleChangeRowsPerPage = event => {
    onPageLimit(event);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader title="Visitor registrations" />
        <Divider />
        <CardContent className={classes.content}>
          <div className={classes.inner}>
            <TableContainer className={classes.container}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>S No</TableCell>
                    <TableCell>Share image</TableCell>
                    <TableCell>Registration code</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Contact</TableCell>
                    <TableCell>Mobile</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>City</TableCell>
                    <TableCell>Registered</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(!orders || orders.length === 0) ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Typography className={classes.nodata} component="p" variant="body1">
                          No records found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    orders.map((order, index) => (
                      <TableRow key={order.id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          {order.shareImageUrl ? (
                            <a
                              href={order.shareImageUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={order.shareImageUrl}
                                alt="Registration share image"
                                style={{ width: 56, height: 56, objectFit: 'contain' }}
                              />
                            </a>
                          ) : (
                            <Typography variant="body2" color="textSecondary">
                              —
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>{order.registration_code}</TableCell>
                        <TableCell>{order.companyname}</TableCell>
                        <TableCell>{order.contactname}</TableCell>
                        <TableCell>{order.mobilenumber}</TableCell>
                        <TableCell>{order.email}</TableCell>
                        <TableCell>{order.city}</TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {order.createdAt
                              ? moment(order.createdAt).format('DD MMM YYYY hh:mm a')
                              : ''}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Tooltip title="Print sticker">
                            <IconButton
                              aria-label="Print sticker"
                              onClick={() => setPrintVisitor(order)}
                              size="small"
                            >
                              <PrintIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={totalcount || 0}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => setPrintVisitor(null)}
        open={Boolean(printVisitor)}
      >
        <DialogTitle>
          Print sticker
          {printVisitor && printVisitor.registration_code
            ? ` — ${printVisitor.registration_code}`
            : ''}
        </DialogTitle>
        <DialogContent>
          {printVisitor && (
            <VisitorStickerPrint
              contactname={printVisitor.contactname}
              companyname={printVisitor.companyname}
              onClear={() => setPrintVisitor(null)}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  totalcount: PropTypes.number,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageLimit: PropTypes.func.isRequired
};

Results.defaultProps = {
  orders: [],
  totalcount: 0
};

export default Results;
